import {
  CLEAR_UNREAD_SYSTEM_NOTIFICATIONS,
  CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_ERROR,
  CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS,
  LOAD_ACCOUNTS,
  LOAD_ACCOUNTS_ERROR,
  LOAD_ACCOUNTS_SUCCESS,
  LOAD_DATA,
  LOAD_DATA_ERROR,
  LOAD_DATA_SUCCESS,
  LOAD_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_ERROR,
  LOAD_NOTIFICATIONS_SUCCESS,
  SAVE_REFERRAL,
  SAVE_REFERRAL_ERROR,
  SAVE_REFERRAL_SUCCESS,
  SWITCH_ACCOUNT,
  SWITCH_ACCOUNT_ERROR,
} from './constants';

export const loadData = (query) => ({
  type: LOAD_DATA,
  query,
});

export const loadDataSuccess = (data) => ({
  type: LOAD_DATA_SUCCESS,
  data,
});

export const loadDataError = (error) => ({
  type: LOAD_DATA_ERROR,
  error,
});

export const loadNotifications = (page) => ({
  type: LOAD_NOTIFICATIONS,
  page,
});

export const notificationsLoaded = (notifications) => ({
  type: LOAD_NOTIFICATIONS_SUCCESS,
  notifications,
});

export const loadAccounts = () => ({ type: LOAD_ACCOUNTS });

export const loadAccountsError = (error) => ({
  type: LOAD_ACCOUNTS_ERROR,
  error,
});

export const loadAccountsSuccess = (organization, accounts) => ({
  type: LOAD_ACCOUNTS_SUCCESS,
  accounts,
  organization,
});

export const notificationsLoadingError = (error) => ({
  type: LOAD_NOTIFICATIONS_ERROR,
  error,
});

export const clearUnreadSystemNotifications = (patient) => ({
  type: CLEAR_UNREAD_SYSTEM_NOTIFICATIONS,
  patient,
});

export const systemUnreadNotificationsCleared = () => ({
  type: CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_SUCCESS,
});

export const systemUnreadNotificationsClearingError = (error) => ({
  type: CLEAR_UNREAD_SYSTEM_NOTIFICATIONS_ERROR,
  error,
});

export const saveReferral = (referral) => ({
  type: SAVE_REFERRAL,
  referral,
});

export const saveReferralSuccess = (response, notification) => ({
  type: SAVE_REFERRAL_SUCCESS,
  response,
  notification,
});

export const saveReferralError = (error) => ({
  type: SAVE_REFERRAL_ERROR,
  error,
});

export const switchAccount = (organization, account) => ({
  type: SWITCH_ACCOUNT,
  organization,
  account,
});

export const switchAccountError = (error) => ({
  type: SWITCH_ACCOUNT_ERROR,
  error,
});
